// extracted by mini-css-extract-plugin
export default {"otherRadioWrapper":"inputStyles_otherRadioWrapper__gilp7","otherInputWrapper":"inputStyles_otherInputWrapper__fxzn+"};